import { createAction, props } from '@ngrx/store';
import { NavigationConfig } from '../models/shared.model';

import { ESharedActions, ENavigationActions } from './shared.state';

/**
 * Public. Init action
 */
export const INIT = createAction(ESharedActions.INIT, props<{ isCaiss: boolean }>());

/**
 * Public. Navigation configuration
 */
export const NAVIGATION_CONFIG = createAction(ENavigationActions.CONFIG, props<{ payload: NavigationConfig }>());

/**
 * Public. Completes the step
 */
export const COMPLETE_STEP = createAction(ESharedActions.COMPLETE_STEP, props<{ payload: number }>());

export const ACTIVE_STEP = createAction(ESharedActions.CURRENT_STEP, props<{ step: number }>())

/**
 * Public. Saves the request id
 */
export const SAVE_REQUEST_ID = createAction(ESharedActions.SAVE_REQUEST_ID, props<{ id: string }>());

/**
 * Public. Saves the form responses
 */
export const SAVE_FORM_RESPONSES = createAction(ESharedActions.SAVE_FORM_RESPONSES, props<{ responses: any }>());

/**
 * Public. Saves the expedient
 */
export const SAVE_EXPEDIENT = createAction(ESharedActions.SAVE_EXPEDIENT, props<{ responses: any }>());

/**
 * Public. Resets the form
 */
export const RESET_FORM = createAction(ESharedActions.RESET_FORM);

// Private

export const SIGNATURE_ACTION = createAction(ESharedActions.LOAD_SIGNATURE_MODULE, props<{ step: any }>());
